/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StrandsRequest,
  StrandsResponse,
} from '../models/index';
import {
    StrandsRequestFromJSON,
    StrandsRequestToJSON,
    StrandsResponseFromJSON,
    StrandsResponseToJSON,
} from '../models/index';

export interface ToggleStrandsRequest {
    seqAnalSessionId: string;
    strandsRequest?: StrandsRequest;
}

/**
 * 
 */
export class DNAApi extends runtime.BaseAPI {

    /**
     * Switch specified sequences to opposite strand (DNA only)
     * Switch specified sequences to opposite strand
     */
    async toggleStrandsRaw(requestParameters: ToggleStrandsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StrandsResponse>> {
        if (requestParameters.seqAnalSessionId === null || requestParameters.seqAnalSessionId === undefined) {
            throw new runtime.RequiredError('seqAnalSessionId','Required parameter requestParameters.seqAnalSessionId was null or undefined when calling toggleStrands.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sequenceAnalyzer/session/{seqAnalSessionId}/strands`.replace(`{${"seqAnalSessionId"}}`, encodeURIComponent(String(requestParameters.seqAnalSessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StrandsRequestToJSON(requestParameters.strandsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StrandsResponseFromJSON(jsonValue));
    }

    /**
     * Switch specified sequences to opposite strand (DNA only)
     * Switch specified sequences to opposite strand
     */
    async toggleStrands(requestParameters: ToggleStrandsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StrandsResponse> {
        const response = await this.toggleStrandsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
